import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import * as XLSX from 'xlsx';
import { getObservations ,getMyAssignedObservations} from '../../services/observationAPI';
import useSelection from 'antd/es/table/hooks/useSelection';
import { useSelector } from 'react-redux';
const CompletedPage = () => {
    const { observationId } = useParams();
    const navigate = useNavigate();
    const [observation, setObservation] = useState(null);
    const [loading, setLoading] = useState(true);
    const {user}= useSelector((state)=>state.profile)


    useEffect(() => {
        const fetchData = async () => {
            try {
                if (user.accountType === "Admin"){
                    const observationsData = await getObservations();
                

                  // Make sure this function exists
                const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                if (foundObservation) {
                    setObservation(foundObservation);
                }
             }
                else{
                    const observationsData = await getMyAssignedObservations();
                    const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                if (foundObservation) {
                    setObservation(foundObservation);
                }
                }
                
            } catch (error) {
                console.error('Error fetching data:', error);
                toast.error('Failed to load data');
                if(user.accountType==="Admin"){
                    navigate('/admin/my-actions')
                }
                else{
                    navigate('/employee/my-actions');
                }
                
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [observationId, navigate]);

    const downloadExcel = () => {
        if (!observation) return;

        // Prepare the data for Excel
        const data = [
            {
                "Observation ID": observation._id,
                "Description": observation?.description,
                "Status": observation?.status,
                "Area": observation.area?.name || '',
                "Reported By": observation.observedBy?.firstName || '',
                "Corrective Action": observation.correctiveAction?.action || '',
                "Corrective Action Responsible Person": observation.correctiveAction?.responsiblePerson || '',
                "Corrective Action Deadline": observation.correctiveAction?.deadline || '',
                "Response": observation.responseData?.response || '',
                "Rejection Reason": observation.responseData?.rejectionReason || '',
            },
        ];

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        // Convert the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(data);
        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Observation Details");
        // Generate the Excel file
        XLSX.writeFile(wb, `observation-${observationId}.xlsx`);
    };

    if (loading) {
        return <div className="flex justify-center items-center h-64">Loading...</div>;
    }

    if (!observation) {
        return <div className="text-center">Observation not found.</div>;
    }

    return (
        <div className="max-w-3xl mx-auto p-4 space-y-8">
            <h1 className="text-3xl font-bold">Completed</h1>

            <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <h2 className="text-xl font-semibold">Observation Details</h2>
                <p>Description: {observation?.description}</p>
                <p>Area: {observation.area?.name}</p>
                <p>Reported by: {observation?.observedBy?.firstName} {observation?.observedBy?.lastName} ({observation?.observedBy?.email})</p>
                {observation?.photos[0] && (
                    <p>Image: <img src={observation?.photos[0]} height={400} width={400}/> </p>
                )}
                
                {observation.correctiveAction?.action && (
                    <p>Corrective Action: {observation.correctiveAction.action}</p>
                )}
                {observation.correctiveAction?.responsiblePerson && (
                    <p>
                  
                      Responsible Person:{' '}
                        {observation.correctiveAction.responsiblePerson.firstName} {observation.correctiveAction.responsiblePerson.lastName} ({observation.correctiveAction.responsiblePerson.email})
                    </p>
                )}
                {observation.correctiveAction?.deadline && (
                    <p>Deadline: {new Date(observation.correctiveAction.deadline).toLocaleDateString()}</p>
                )}
                {observation.responseData?.response && (
                    <p>Response: {observation.responseData.response}</p>
                )}
                {observation.responseData?.rejectionReason && (
                    <p>Rejection Reason: {observation.responseData.rejectionReason}</p>
                )}
            </div>

            <div className="flex justify-end">
                <button
                    onClick={downloadExcel}
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                >
                    Download Details (Excel)
                </button>
            </div>
            <div className="flex justify-start">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"

                >
                    Back to List
                </button>
            </div>
        </div>
    );
};

export default CompletedPage;

